import React from 'react'; //eslint-disable-line
import './headingBar.less';

export default function({ title, additional }) {
	return (
		<div className="heading-bar">
			<div className="heading-bar-title">{title}</div>
			{additional && <div className="heading-bar-additional">{additional}</div>}
		</div>
	);
}



// WEBPACK FOOTER //
// ./src/components/Modules/HeadingBar/index.js